import { FiShield, FiZap, FiGlobe, FiCpu, FiLayers, FiCode, FiServer, FiClock } from "react-icons/fi";
import { FaNodeJs, FaServer, FaCode } from "react-icons/fa";
import { LuSettings, LuUsers, LuShieldCheck, LuPercent, LuShield, LuCpu, LuClipboardList, LuCircleCheck, LuCode, LuBug, LuRocket, LuDatabase, LuClock } from "react-icons/lu";

export const nodeBenefits = [
  {
    icon: <FiZap className="w-8 h-8" />,
    title: "V8 Engine Performance",
    desc: "Node.js uses Google's V8 engine to compile JavaScript directly to machine code for extreme speed.",
  },
  {
    icon: <FiCpu className="w-8 h-8" />,
    title: "Event-Driven I/O",
    desc: "Non-blocking architecture allows handling thousands of concurrent connections with minimal overhead.",
  },
  {
    icon: <FiLayers className="w-8 h-8" />,
    title: "NPM Ecosystem",
    desc: "Access to over a million packages ensures we can build complex features rapidly and reliably.",
  },
];

export const nodeServices = [
  {
    icon: <FaNodeJs size={36} />,
    title: "Real-time Applications",
    description: "Building fast, scalable chat apps, collaboration tools, and live dashboards using WebSockets.",
    image: "/images/api-dev.jpg",
    link: "#",
  },
  {
    icon: <FaServer size={36} />,
    title: "Microservices Architecture",
    description: "Developing decoupled, scalable services that communicate seamlessly for large-scale systems.",
    image: "/images/backend-dev.jpg",
    link: "#",
  },
  {
    icon: <FaCode size={36} />,
    title: "API Development",
    description: "Engineering robust RESTful and GraphQL APIs that power both web and mobile experiences.",
    image: "/images/custom-dev.jpg",
    link: "#",
  },
];

export const nodeFaqs = [
  {
    q: "Why should I choose Node JS development in India for my project?",
    a: "Node JS development in India offers cost-effective solutions with experienced developers who can build fast, scalable, and real-time applications. Indian Node.js experts deliver high-performance backend solutions ideal for modern web and mobile apps.",
  },
  {
    q: "What can NodeJS developers do for my business?",
    a: "NodeJS developers specialize in building server-side applications, APIs, and real-time solutions. They ensure your application is secure, scalable, and capable of handling high traffic while delivering smooth performance.",
  },
  {
    q: "How do I choose the best NodeJS development service for my project?",
    a: "To choose the best NodeJS development service, look for experienced developers, a strong project portfolio, positive client reviews, and expertise in building scalable applications. The best teams also offer transparent communication and ongoing support.",
  },
];

export const nodeProcessSteps = [
  {
    step: "01",
    title: "System Architecture",
    description: "Designing the non-blocking event loop strategy and choosing between REST, GraphQL, or WebSockets.",
    points: ["Architecture mapping", "Database selection", "Queue strategy"],
  },
  {
    step: "02",
    title: "API Orchestration",
    description: "Developing clean, documented endpoints with robust authentication (JWT/OAuth).",
    points: ["Endpoint development", "Security hardening", "Swagger documentation"],
  },
  {
    step: "03",
    title: "Load Testing",
    description: "Simulating high traffic to ensure the event loop remains responsive under extreme pressure.",
    points: ["Traffic simulation", "Latency monitoring", "Auto-scaling validation"],
  },
];

export const nodeTechStack = ["Node.js", "Express", "NestJS", "Socket.io", "MongoDB", "Redis", "Docker"];

export const nodeHeroData = {
  backgroundImage: "/images/serviceBanners/NodeBanner.webp",
  whiteImage: "/images/serviceBanners/NodeJSBannerW.webp",
  subTitle: "Node.js Development Services",
  title: (
    <>
      Scalable & Fast <br /> <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">Node.js Development </span> Solutions
    </>
  ),
  description:
    "We build highly scalable and fast Node.js backend systems using event driven and non blocking architecture to deliver real time applications, improved performance, and efficient server side solutions for modern businesses.",
  primaryButton: {
    title: "Get Started",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "High Concurrency",
      desc: "Handle thousands of simultaneous requests efficiently.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "V8 Engine Speed",
      desc: "Fast execution powered by Chrome V8 engine.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Event-Driven Architecture",
      desc: "Asynchronous processing with low system overhead.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "NPM Ecosystem",
      desc: "Huge package library for fast development and integration.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};
export const nodeStatsData = [
  {
    icon: LuSettings,
    value: "180+",
    label: "Node.js Projects",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "75+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.95%",
    label: "Service Uptime",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuCpu,
    value: "8M+",
    label: "Daily Hits",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "35%",
    label: "Cost Optimized",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Secure APIs",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

export const nodeSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Node.js Backend Solutions We Build",
  buildCards: [
    {
      title: "Real-time Messaging Systems",
      desc: "Build low-latency chat, notifications, and real-time communication systems.",
      icon: LuClock,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Custom REST APIs",
      desc: "Create secure and well-documented REST APIs with clean architecture.",
      icon: LuCode,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "GraphQL Endpoints",
      desc: "Design efficient GraphQL APIs with flexible and optimized data fetching.",
      icon: LuSettings,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Microservices Architecture",
      desc: "Develop scalable distributed backend systems using event-driven services.",
      icon: LuCpu,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Database Architecture",
      desc: "Integrate and optimize MongoDB, PostgreSQL, and Redis for high performance.",
      icon: LuDatabase,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Serverless Deployment",
      desc: "Deploy scalable Node.js functions using AWS Lambda and cloud platforms.",
      icon: LuRocket,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "NODE.JS ENGINEERING PROCESS",
  processTitle: "Node.js Engineering Process",
  processSteps: [
    {
      step: "01",
      title: "Schema Design",
      description: "Define scalable MongoDB and SQL data models with proper relationships.",
      icon: LuClipboardList,
    },
    {
      step: "02",
      title: "API Routing",
      description: "Set up Express or NestJS routes with clean middleware structure.",
      icon: LuCode,
    },
    {
      step: "03",
      title: "Logic Development",
      description: "Build non-blocking backend logic and real-time socket handling.",
      icon: LuSettings,
    },
    {
      step: "04",
      title: "Auth & Security",
      description: "Implement JWT/OAuth authentication with secure access controls.",
      icon: LuShieldCheck,
    },
    {
      step: "05",
      title: "Performance Optimization",
      description: "Improve event loop efficiency and remove memory leaks completely.",
      icon: LuCircleCheck, // Safe icon compilation replacement
    },
    {
      step: "06",
      title: "CI/CD Deployment",
      description: "Automate deployment using Docker and continuous integration pipelines.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY CHOOSE NODE.JS?",
  benefitsTitle: "Why Node.js is the Right Choice",
  benefits: [
    "High event-loop concurrency",
    "Unified JavaScript stack",
    "Fast request processing",
    "Huge NPM ecosystem",
    "Low memory usage",
    "Real-time app support",
    "Cloud-native compatibility",
  ],
  logoImage: "/images/serviceBanners/NodeBanner.webp",
  whiteLogoImage: "/images/serviceBanners/NodeJSBannerW.webp",
};

export const nodePortfolioData = {
  subtitle: "OUR WORK",
  title: "NodeJS Backends We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "LiveChat Engine",
      badge: "Socket.io Service",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "High-speed communication hub supporting 50,000+ active connections concurrently with zero lag.",
      downloads: "5M+ Msg/Day",
      rating: "4.9",
      image: "/images/WebAppDevelopment/Node_JS_Development.png",
    },
    {
      title: "RetailCore API",
      badge: "GraphQL Microservices",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Robust product inventory gateway for eCommerce aggregators with smart field resolving.",
      downloads: "10M+ Req/Day",
      rating: "5.0",
      image: "/images/serviceBanners/NodeBanner.webp",
    },
  ],
};

export const nodeTechnologiesData = {
  techTitle: "TECHNOLOGIES WE USE",
  technologies: [
    { name: "REST API", icon: "RestAPI" },
    { name: "SQLite", icon: "SQLite" },
    { name: "Firebase", icon: "Firebase" },
    { name: "Provider", icon: "Provider" },
  ],
  trustTitle: "TRUSTED BY BUSINESSES WORLDWIDE",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

export const nodeAboutData = [
  {
    title: "Node JS Development Services for Scalable Backend Systems",
    content: (
      <>
        Modern applications require backend systems that can manage growing traffic, real-time interactions, and complex operations without slowing down. Reliable{" "}
        <b className="text-text-primary font-semibold">node js development services</b> help businesses create scalable digital infrastructures designed for speed, flexibility, and
        long-term performance. Many organizations struggle with backend systems that become difficult to scale as user demand increases. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, Node.js solutions are developed around business objectives, operational efficiency, and future
        scalability to help companies build dependable digital ecosystems.
      </>
    ),
  },
  {
    title: "Node JS Development Company for High-Performance Applications",
    content: (
      <>
        A successful backend system depends on how efficiently it handles requests, integrations, and user interactions. A trusted{" "}
        <b className="text-text-primary font-semibold">node js development company</b> helps businesses create structured server environments that improve responsiveness and
        support seamless digital experiences. Companies investing in <b className="text-text-primary font-semibold">node js web development</b> often benefit from improved
        application efficiency because systems are designed to support modern business demands without unnecessary complexity. Tycho Technologies focuses on practical Node.js
        architectures that improve backend performance while supporting business growth and technical flexibility.
      </>
    ),
  },
  {
    title: "Hire Node JS Developers for Smarter Digital Infrastructure",
    content: (
      <>
        Businesses handling real-time systems and growing user activity need backend environments that remain stable and adaptable. Companies looking to{" "}
        <b className="text-text-primary font-semibold">hire node js developers</b> often prioritize performance, maintainability, and stronger system reliability for long-term
        digital success. Organizations aiming to strengthen infrastructure often combine backend ecosystems with{" "}
        <a href="https://tychotechnologies.com/dotnet-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          dot net development services
        </a>{" "}
        to improve flexibility and support enterprise-level digital transformation.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a Node JS Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">node js development company in india</b> continues to grow as businesses seek reliable and scalable
        backend technologies. Companies investing in <b className="text-text-primary font-semibold">node js development services india</b> often focus on performance, operational
        stability, and long-term digital scalability. Businesses partnering with Tycho Technologies gain access to customized Node.js frameworks designed around measurable business
        objectives and technical requirements. Many organizations also strengthen application performance through{" "}
        <a href="https://tychotechnologies.com/backend-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          backend app development services
        </a>{" "}
        to create secure and future-ready digital systems.
      </>
    ),
  },
];
